import {Dispatch} from "redux";
import {monthTableAction, monthTableActionTypes} from "../../types/dashboard/monthTable";
import axios from "axios";


export const getMonthTableData = (operator:string): any => {
    return async (dispatch: Dispatch<monthTableAction>) => {
        try {
            dispatch({type: monthTableActionTypes.FETCH_MONTH_TABLE_DATA});
            const response = await axios({
                method: 'get',
                url: `/api/widgets/month_table?operator=${operator}`,
                withCredentials: false
            });
            dispatch({type: monthTableActionTypes.FETCH_MONTH_TABLE_DATA_SUCCESS, payload: response.data})
        } catch (error) {
            dispatch({type: monthTableActionTypes.FETCH_MONTH_TABLE_DATA_ERROR, payload: `Something went wrong, please check Month Table action controller. ${error}`});
        }
    }
}